import { render, staticRenderFns } from "./InvalidIDModal.vue?vue&type=template&id=b3081ac4&scoped=true&"
import script from "./InvalidIDModal.vue?vue&type=script&lang=js&"
export * from "./InvalidIDModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3081ac4",
  null
  
)

export default component.exports